import React from 'react';
import Loging from './Loging';

const Login = () => {
  return (
    <>
      <Loging />
    </>
  )
}
export default Login;

